import { AudioFormat } from '../player/enums';
import { AudioCodec } from '../player/enums/audio-codecs';
const normalizeCodec = (codec) => {
    return codec.trim().toLowerCase().replace(/[^a-z0-9]/g, '');
};
export const codecToAudioFormat = (codec) => {
    if (!codec) {
        return null;
    }
    const normalizedCodec = normalizeCodec(codec);
    if (normalizedCodec === AudioCodec.EC3 ||
        normalizedCodec === AudioCodec.EAC3) {
        return AudioFormat.DOLBY;
    }
    return AudioFormat.STEREO;
};
export const mapAudioTrackFormat = (track) => {
    const audioFormat = codecToAudioFormat(track.codec);
    if (!audioFormat) {
        return track;
    }
    return {
        ...track,
        audioFormat,
    };
};
